export function GetParam(path = window.location.href) {
  const query = {}
  const queryList = path.split('?')
  // 获取query
  if (queryList[1]) {
    const str = queryList[1].replace('#/', '')
    const queryDataList = str.split('&')
    queryDataList.map((item) => {
      const queryData = item.split('=')
      query[queryData[0]] = queryData[1]
    })
    return query
  } else {
    return false
  }
}

export const buildUrl = (path) => {
  const query = {}
  const queryList = path.split('?')
  // 获取query参数(排除code、state和ticket)
  if (queryList[1]) {
    const queryDataList = queryList[1].split('&')

    queryDataList.map((item) => {
      const queryData = item.split('=')
      // ✅ 修复逻辑错误: 改为 && (两个条件都要满足才排除)
      if (queryData[0] != 'code' && queryData[0] != 'state' && queryData[0] != 'ticket') {
        query[queryData[0]] = queryData[1]
      }
    })
  }

  let str = ''
  Object.keys(query).forEach(key => {
    str += `&${key}=${encodeURIComponent(query[key])}`
  })

  // ✅ 修复多余问号: 只有存在参数时才添加 ?
  if (str) {
    return `${queryList[0]}?${str.slice(1)}`
  } else {
    return queryList[0]
  }
}
